import React, { useEffect, Suspense } from 'react';
import { Alert, Button, Row, Col, Tab, Nav, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { getEmployee } from '../../redux/employees/actions';
/*import ResetPass from './ResetPassword';
import GeneralInfo from './GeneralInfo';
import AddressUserInfo from './AddressUserInfo';
import UserEducation from './UserEducation';
import DependantsUpdate from './DependantsUpdate';
import UserVaccination from './UserVaccination';
import SecurityBeneficersUpdate from './SecurityBeneficersUpdate';
import EmergencyContacts from './EmergencyContacts';*/
import { requestNotNeedUpdate } from '../../redux/updateUserData/actions'; 
import { withRouter } from 'react-router-dom';

import {
  getAreas,
  getCarpetas
} from "../../redux/gestorDocumental/actions";

const ResetPass  = React.lazy(() => import('./ResetPassword'));
const GeneralInfo = React.lazy(() => import('./GeneralInfo'));
const AddressUserInfo = React.lazy(() => import('./AddressUserInfo'));
const UserEducation  = React.lazy(() => import('./UserEducation'));
const DependantsUpdate = React.lazy(() => import('./DependantsUpdate'));
const UserVaccination = React.lazy(() => import('./UserVaccination'));
const SecurityBeneficersUpdate = React.lazy(() => import('./SecurityBeneficersUpdate'));
const EmergencyContacts = React.lazy(() => import('./EmergencyContacts'));

const UserInfo = props => {
  //Redux
  const dispatch = useDispatch();
  const loaderNotNeedUpdate = useSelector(store => store.userDataUpdate.loaderNotNeedUpdate);
  const loading = useSelector(store => store.employees.loading);
  const userInfo = useSelector(store => store.employees.employee);
  //const userN = useSelector((store) => store.auth.username);
  //const userId = useSelector((store) => store.auth.id);

  const {
    loadingAreas,
    loadingCarpetas, 
    areas, 
    carpetas,
    areasError,
    carpetasError
  } = useSelector((store) => store.gestorDocumental);
  //Methods
  useEffect(() => {
    dispatch(getEmployee(props.match.params.id, parseInt(props.match.params.type)));
    dispatch(getAreas());
    dispatch(getCarpetas());
  }, []);//dispatch, props.match.params.id, props.match.params.type

  const onUserNotNeedUpdate = () => dispatch(requestNotNeedUpdate(props, props.match.params.id, parseInt(props.match.params.type)));
 
  return (
    <>
     <div className="container mt-5 mb-3">
       <div className="d-flex justify-content-between align-items-center my-5">
          <p className="text-uppercase font-weight-bold">Mi información está bien y no requiero actualizarla</p>
          <Button
              className="rounded-pill"
              disabled={loaderNotNeedUpdate}
              onClick={ () => onUserNotNeedUpdate() }
              variant="warning"
              size="sm"
              type="button">
                {
                  loaderNotNeedUpdate ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  ): null
                }
                Aceptar</Button>
        {
          areasError || carpetasError ? (
            <Alert variant="danger">
              {
                areasError && (areasError)
              }
              {
                carpetasError && (carpetasError)
              }
            </Alert>
          ) : null
        }
       </div>
       <Tab.Container defaultActiveKey="generalInfo">
         <Row>
          <Col sm={12} md={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="generalInfo">Información general</Nav.Link>
              </Nav.Item>
              <Nav.Item >
                <Nav.Link eventKey="userAddress">Dirección</Nav.Link>
              </Nav.Item>
              <Nav.Item >
                <Nav.Link eventKey="userEducation">Educación</Nav.Link>
              </Nav.Item>
              <Nav.Item >
                <Nav.Link eventKey="userDependants">Familiares dependientes</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="securityBeneficers">Beneficiarios</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="userVacci">Vacunación</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="userEmergCont">Cont. de emergencia</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="resetPass">Cambiar contraseña</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Link to={`/detalle-empleado/${props.match.params.id}/${props.match.params.type}`} className="nav-link">Regresar</Link>
              </Nav.Item>
            </Nav>
           </Col>
           <Col sm={12} md={9}>
             {
               loading || loadingAreas || loadingCarpetas ? (
                <div className="d-flex justify-content-center mt-4">
                  <Spinner 
                    animation="border" 
                    role="status" 
                    className="d-flex justify-content-center" />
                </div>
              ):(
                <Suspense fallback={
                  <div className="d-flex justify-content-center mt-4">
                    <Spinner 
                      animation="border" 
                      role="status" 
                      className="d-flex justify-content-center" />
                  </div>
                }>
                  <Tab.Content className="p-2">
                    <Tab.Pane eventKey="generalInfo">
                      <GeneralInfo 
                        areas={areas} 
                        carpetas={carpetas} 
                        userInf={userInfo} 
                        iType={parseInt(props.match.params.type)} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="userAddress">
                      <AddressUserInfo 
                        areas={areas} 
                        carpetas={carpetas}
                        userInf={userInfo} 
                        iType={parseInt(props.match.params.type)} 
                        tipo="croquis" />
                    </Tab.Pane>
                    <Tab.Pane eventKey="userEducation">
                      <UserEducation 
                        areas={areas} 
                        carpetas={carpetas}
                        id={props.match.params.id} 
                        type={props.match.params.type} 
                        userInfo={userInfo} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="userDependants">
                      <DependantsUpdate 
                        areas={areas} 
                        carpetas={carpetas}
                        id={props.match.params.id} 
                        type={props.match.params.type} 
                        userInfo={userInfo}/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="securityBeneficers">
                      <SecurityBeneficersUpdate id={props.match.params.id} type={props.match.params.type} userInfo={userInfo} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="userVacci">
                      <UserVaccination 
                        areas={areas} 
                        carpetas={carpetas} 
                        id={props.match.params.id} 
                        type={props.match.params.type} 
                        userInfo={userInfo} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="userEmergCont">
                      <EmergencyContacts id={props.match.params.id} type={props.match.params.type} userInf={userInfo} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="resetPass">
                      <ResetPass />
                    </Tab.Pane>
                  </Tab.Content>
                </Suspense>
              )
             }
          </Col>
         </Row>
       </Tab.Container>
     </div>
    </>
  )
}
export default withRouter(UserInfo)